<template>
  <div class="mb-6">

    <div class="columns is-multiline">
      <div class="column is-12-mobile is-2-tablet">
        <InputSelect
          name="Chiamata persa"
          v-model="filters.lost"
          @select="onFilterInput"
          :options="[{'label': 'Sì', value: true}, {'label': 'No', value: false}]"
          id="value"
          track-by="value"
          label="label"
        />
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <InputText :hasIconSearch="true" name="Occupante" v-model="filters.occupantText" @input="onFilterInput" />
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <InputText :hasIconSearch="true" name="Proprietario" v-model="filters.clientText" @input="onFilterInput" />
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <InputText :hasIconSearch="true" name="Luogo" v-model="filters.place" @input="onFilterInput" />
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <InputText :hasIconSearch="true" name="Impianto" v-model="filters.implant" @input="onFilterInput" />
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <InputSelect
          name="Installatore"
          v-model="filters.installer"
          :options="installers"
          :loading="waitInstallers"
          :disabled="waitInstallers"
          id="_id"
          track-by="_id"
          :custom-label="$clientName"
          @select="onFilterInput"
          @remove="onFilterInput"
        />
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <div class="field">
          <label class="label">Intervallo date</label>
          <InputDate v-model="filters.range" @update="onFilterInput" placeholder="Intervallo date" :range="true" :showIcon="true" />
        </div>
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <InputSelect
          name="Collaboratore"
          v-model="filters.operator"
          :options="$store.getters.operatorsFilter"
          id="_id"
          track-by="_id"
          :custom-label="$fullname"
          @select="filterOperators"
          @remove="filterOperators(false)"
        />
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <InputSelect
          name="Tipologia"
          v-model="filters.type"
          :options="$store.state.operation_types"
          id="name"
          track-by="name"
          label="name"
          @select="onFilterInput"
          @remove="onFilterInput"
        />
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <InputText :hasIconSearch="true" name="Telefono" v-model="filters.telephone" @input="onFilterInput" />
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <InputText :hasIconSearch="true" name="Note" v-model="filters.notes" @input="onFilterInput" />
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <InputSelect
          name="Priorità"
          v-model="filters.priority"
          :options="['Bassa', 'Media', 'Alta']"
          @select="onFilterInput"
          @remove="onFilterInput"
        >
          <template #option="props">
            <div class="is-flex is-justify-content-space-between" >
              <div>{{ props.option }}</div>
              <div :style="{ width: '50px', background: calcBg(props.option)}"></div>
            </div>
          </template>
          <template #singleLabel="props">
            <div class="is-flex is-justify-content-space-between" >
              <div>{{ props.option }}</div>
              <div :style="{ width: '50px', background: calcBg(props.option)}"></div>
            </div>
          </template>
        </InputSelect>
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <InputSelect
          name="Concluso"
          v-model="filters.archived"
          @select="onFilterInput"
          :options="[{'label': 'Sì', value: true}, {'label': 'No', value: false}]"
          id="value"
          track-by="value"
          label="label"
        />
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <InputSelect
          name="Ordina per data"
          v-model="filters.dateSort"
          @select="onFilterInput"
          :options="[{'label': 'Più recente', value: 'desc'}, {'label': 'Meno recente', value: 'asc'}]"
          id="value"
          track-by="value"
          label="label"
        />
      </div>
      <div class="column is-12-mobile is-4-tablet">
        <label class="label">&nbsp;</label>
        <div class="buttons is-flex">
          <button class="button" @click="resetFilters()"><font-awesome-icon icon="filter-circle-xmark" />Reset</button>
          <router-link to="/chiamate/new" class="button is-primary is-hidden-touch" @click="resetFilters()"><font-awesome-icon icon="plus" />Aggiungi</router-link>
        </div>
      </div>
    </div>

    <div class="b-table has-pagination" :class="{'is-loading': loading}">
      <div class="table-wrapper has-mobile-cards">
        <table class="table is-fullwidth is-striped is-hoverable">
          <thead>
          <tr>
            <th style="width: 24px;"></th>
            <th><div>Occupante</div><div><small class="has-text-grey is-abbr-like">Proprietario</small></div></th>
            <th>Luogo</th>
            <th>Impianto</th>
            <th>Data</th>
            <th>Collaboratore</th>
            <th>Tipologia</th>
            <th>Telefono</th>
            <th>Note</th>
            <th style="min-width: 100px;"></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(call, index) in calls" :key="index">
            <td style="position: relative; padding: 0;">
              <div v-if="call.lost" title="Chiamata persa" class="has-background-info" style="height: 100%;width: 100%;position: absolute;top: 0;left: 0;"></div>
            </td>
            <td data-label="Occupante">
              <router-link v-if="call.occupant" :to="'/clienti/' + call.occupant._id">
                <ClientHeading :client="call.occupant" />
              </router-link>
              <router-link v-if="call.client" :to="'/clienti/' + call.client._id">
                <ClientHeading :client="call.client" :owner="true" />
              </router-link>
              <div v-if="call.tempClient?.name || call.tempClient?.surname || call.tempClient?.business_name">
                <ClientHeading :client="call.tempClient" />
              </div>
              <div v-if="call.tempClient?.name_owner || call.tempClient?.surname_owner || call.tempClient?.business_name_owner">
                <ClientHeading :owner="true" :client="{name: call.tempClient.name_owner, surname: call.tempClient.surname_owner, business_name: call.tempClient.business_name_owner}" />
              </div>
              <div v-if="call?.tempClient?.installer" class="has-text-grey is-abbr-like mt-1">
                <small>
                  <div><b>Installatore</b></div>
                  <div>{{ installerName(call) }}</div>
                </small>
              </div>
            </td>
            <td data-label="Luogo">
              <router-link v-if="call.place" :to="'/luoghi/' + call.place._id">
                <AddressDisplay :value="call.place" />
              </router-link>
              <!--<div v-else-if="call.client">
                <div>{{call.client.city}}</div>
                <div><small class="has-text-grey is-abbr-like" :title="$fulladdress(call.client)">{{$fulladdress(call.client)}}</small></div>
              </div>-->
              <div v-else-if="call.tempClient">
                <AddressDisplay :value="call.tempClient" />
              </div>
            </td>
            <td data-label="Impianto">
              <router-link v-if="call.implant" :to="'/impianti/' + call.implant._id" style="white-space: pre-line">
                {{$implantName(call.implant)}}
                <div class="tags" v-if="calcTypes(call.implant)?.length">
                  <span class="tag is-dark" v-for="(type, index) in calcTypes(call.implant)" :key="index">{{ type }}</span>
                </div>
              </router-link>
              <div v-if="call.tempClient?.brand || call.tempClient?.model">
                {{implantTempName(call.tempClient)}}
              </div>
            </td>
            <td data-label="Data">
              <div v-if="call.date">{{new Date(call.date).toDisplay()}}</div>
              <div v-if="call.time"><small class="has-text-grey is-abbr-like">{{call.time}}</small></div>
            </td>
            <td data-label="Collaboratore">
              <div class="tags" v-if="call.operator">
                <span :class="'tag is-info ' + (call?.operator?.color ? call?.operator?.color + '-card' : '')">
                  {{$fullname(call.operator)}}
                </span>
              </div>
            </td>
            <td data-label="Tipologia">
              {{call.type}}
            </td>
            <td data-label="Telefono">
              <div v-for="(contact, index) in getContacts(call)" :key="index">
                  <div v-if="contact.telephone" class="is-flex is-align-items-center" :class="{'mt-2': index}">
                    <div class="mr-2" style="width: 110px; font-size: 0.9rem;">
                      <div>{{contact.name}}</div>
                      <div>{{contact.telephone}}</div>
                    </div>
                    <a class="button is-warning is-small" :href="contact.telephone ? 'tel:'+contact.telephone : ''">
                      <font-awesome-icon icon="phone" class="m-0" />
                    </a>
                  </div>
                </div>
            </td>
            <td data-label="Note" :style="{ background: calcBg(call.priority), 'white-space': 'pre-wrap' }">
              {{call.notes}}
            </td>
            <td class="is-actions-cell is-justify-content-flex-end">
              <div class="buttons is-right">
                <button class="button is-primary" :class="call.pinned ? 'is-solid' : 'is-light'" type="button" @click="togglePinned(call)" title="Preferito" :disabled="call.waitPinned" :aria-pressed="call.pinned ? 'true' : 'false'">
                  <span class="icon" :class="{'is-loading': call.waitPinned}"><font-awesome-icon icon="thumbtack" /></span>
                </button>
                <button v-if="!call.operation" class="button is-danger" @click="openModal(call)" title="Crea appuntamento">
                  <span class="icon"><font-awesome-icon icon="plus" /></span>
                </button>
                <router-link v-if="call.operation" :to="'/appuntamenti/' + call.operation._id" class="button is-primary has-tooltip-arrow has-tooltip-multiline" :data-tooltip="tooltipText(call.operation)" style="max-width: 40px;">
                  <font-awesome-icon icon="file-lines" class="m-0" />
                </router-link>
                <button v-if="!call.archived" class="button is-secondary" @click="archive(call, true)" title="Concludi" :class="[{'is-loading': call.waitArchive}]" :disabled="call.waitArchive">
                  <span class="icon"><font-awesome-icon icon="lock" /></span>
                </button>
                <button v-if="call.archived" class="button is-secondary" @click="archive(call, false)" title="Ripristina" :class="[{'is-loading': call.waitArchive}]" :disabled="call.waitArchive">
                  <span class="icon"><font-awesome-icon icon="lock-open" /></span>
                </button>
                <router-link :to="'/chiamate/' + call._id" class="button is-warning" type="button" title="Modifica" :disabled="call.waitDelete">
                  <span class="icon"><font-awesome-icon icon="pen" /></span>
                </router-link>
                <button class="button is-danger" type="button" @click="deleteCall(call)" title="Elimina" :class="[{'is-loading': call.waitDelete}]" :disabled="call.waitDelete">
                  <span class="icon"><font-awesome-icon icon="trash-can" /></span>
                </button>
              </div>
            </td>
          </tr>
          <tr v-if="calls.length === 0">
            <td colspan="100" class="has-text-centered has-text-grey">
              <i>Nessun risultato</i>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <Pagination :pagination="pagination" @change="getCalls($event)" />
    </div>

    <router-link to="/chiamate/new" class="button is-floating is-primary is-hidden-desktop" title="Nuovo">
      <span class="icon">
        <font-awesome-icon icon="plus" />
      </span>
    </router-link>

    <CallCalendar :call="selectedCall" :open="openModalAppointment" @close="this.openModalAppointment = false" @saved="savedAppointment($event)" />

  </div>
</template>

<script>
import utils from '../utils';
import AddressDisplay from '../components/AddressDisplay.vue'

export default {
  components: {
    AddressDisplay
  },

  data() {
    return {
      filters: {
        ...this.$store.state.filters.call,
        dateSort: this.$store.state.filters.call?.dateSort || {'label': 'Più recente', value: 'desc'}
      },

      calls: [],

      pagination:{
        total: false,
        selected: false
      },

      installers: [],

      loading: true,
      waitInstallers: true,

      openModalAppointment: false,
      selectedCall: null
    }
  },

  methods: {
    resetFilters() {
      this.filters = {
        range: null,
        archived: {'label': 'No', value: false},
        dateSort: {'label': 'Più recente', value: 'desc'},
        occupantText: '',
        clientText: '',
        installer: null
      }

      this.getCalls()
    },

    filterOperators(selected) {
      this.filters.operator = selected
      this.getCalls()
    },

    getCalls(args = {page: 1, size: 30, scroll: 0}) {
      const self = this
      
      this.loading = true

      this.$store.commit('setFilter', {name: 'call', value: this.filters})
      this.$store.commit('setPage', {name: 'call', value: {number: args.page, size: args.size}})

      const lost = this.filters.lost ? this.filters.lost.value : null
      const occupantId = null
      const occupantText = this.filters.occupantText
      const clientId = null
      const clientText = this.filters.clientText
      const place = this.filters.place
      const implant = this.filters.implant
      const startDate = this.filters.range ? this.filters.range.start.toDateInputValue() : null
      const endDate = this.filters.range ? this.filters.range.end.toDateInputValue() : null
      const operator = this.filters.operator ? this.filters.operator._id : null
      const type = this.filters.type ? this.filters.type.name : null
      const installer = this.filters.installer ? this.filters.installer._id : null
      const telephone = this.filters.telephone
      const notes = this.filters.notes
      const priority = this.filters.priority ? this.filters.priority : null
      const archived = this.filters.archived ? this.filters.archived.value : null
      const dateSort = this.filters.dateSort ? this.filters.dateSort.value : 'desc'

      this.$http.get('/call', { params: {
        page: args.page,
        size: args.size,
        lost,
        occupant: occupantId,
        occupantText,
        client: clientId,
        clientText,
        place,
        implant,
        startDate,
        endDate,
        operator,
        type,
        installer,
        telephone,
        notes,
        priority,
        archived,
        dateSort
      } }).then(response => {
        if (response && response.data) {
          this.calls = response.data.records
          this.pagination = {
            total: response.data.totalRecords,
            pages: response.data.totalPages,
            selected: response.data.currentPage
          }

          if (args.scroll) {
            self.$nextTick(() => {
              window.scroll(0, args.scroll)
            })
          }
        }

        this.loading = false
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
        self.loading = false
      })
    },

    deleteCall(call) {
      if (confirm('Eliminare?')) {
        const self = this
        call.waitDelete = true

        this.$http.delete('/call/' + call._id)
        .then(function (response) {
          self.getCalls({page: self.$store.state.pages.call.number, size: self.$store.state.pages.call.size})
        })
        .catch(function (error) {
          console.log(error)
          alert('Errore')
          call.waitDelete = false
        })
      }
    },

    archive(call, value) {
      const self = this
      call.waitArchive = true

      this.$http.put('/call/' + call._id, {archived: value})
      .then(function (response) {
        self.getCalls()
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
        call.waitArchive = false
      })
    },

    togglePinned(call) {
      const self = this
      call.waitPinned = true

      this.$http.put('/call/' + call._id, { pinned: !call.pinned })
      .then(function () {
        self.getCalls({page: self.$store.state.pages.call.number, size: self.$store.state.pages.call.size})
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
        call.waitPinned = false
      })
    },

    openModal(call) {
      this.selectedCall = call

      this.openModalAppointment = true
    },

    savedAppointment(id_operation) {
      this.openModalAppointment = false

      this.$router.push('/appuntamenti/' + id_operation)
    },

    implantTempName(tempClient) {
      let name = ''
      if (tempClient?.brand) {
        name = tempClient?.brand
      }
      if (tempClient?.model) {
        name += ' ' + tempClient?.model
      }

      return name.trim()
    },

    calcTypes(implant) {
      return utils.calcTypes(implant)
    },

    calcBg(priority) {
      return utils.calcPriorityColor(priority)
    },

    tooltipText(operation) {
      let result = "Appuntamento"

      if (operation.appointment_date) {
        result += " " + new Date(operation.appointment_date).toDisplay()
      }

      return result
    },

    installerName(call) {
      return this.$clientName(call?.tempClient?.installer || {})
    },

    getContacts(call) {
      const contacts = [
        ...(call?.tempClient?.contacts || []),
        ...(call?.client?.contacts || []),
        ...(call?.occupant?.contacts || [])
      ]

      if (call.lost && call.lost_number) {
        contacts.push({
          name: 'Chiamata persa',
          telephone: call.lost_number
        })
      }
      
      return contacts.filter((contact, index, arr) => 
        arr.findIndex(c => c.telephone === contact.telephone) === index
      )
    }
  },

  mounted() {
    const self = this

    this.$http.get('/client/filter')
    .then(function (response) {
      if (response && response.data) {
        self.installers = response.data.filter(client => !!client.isInstaller)
      }

      self.waitInstallers = false
    })
    .catch(function (error) {
      console.log(error)
      alert('Errore')
      self.waitInstallers = false
    })

    this.getCalls({page: this.$store.state.pages.call.number, size: this.$store.state.pages.call.size, scroll: this.$store.state.pages.call.scroll})
  },

  created() {
    this.onFilterInput = this.$debounce(() => this.getCalls(), 500)
  },

  beforeUnmount() {
    const scroll = window.top.scrollY
    let page = Object.assign({}, this.$store.state.pages.call)
    page.scroll = scroll
    this.$store.commit('setPage', {name: 'call', value: page})
  }
}
</script>